import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { BudgetFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import BudgetProgress from './BudgetProgress'
import './index.styles.css'
interface Props {
  budget: BudgetFragment
}

const PeriodStatusCard = ({ budget }: Props) => {
  const currentDate = moment().startOf('day')
  const startDate = moment(budget.effectiveFrom).startOf('day')
  const daysLeft = startDate.diff(currentDate, 'days')

  const translationKey = budget._policies?.update.can
    ? i18n.t('budgets.detail.period_status.start_date', {
        start_date: dateBackendDateTimeToUI(budget.effectiveFrom),
      })
    : i18n.t('budgets.detail.period_status.start_date_viewer', {
        start_date: dateBackendDateTimeToUI(budget.effectiveFrom),
      })

  return (
    <Box className={'PeriodStatusCard_container'}>
      <Box gap="s32" width="full" flexDirection="row" alignItems="center">
        {budget.started ? (
          <BudgetProgress budget={budget} />
        ) : (
          <Box gap="s16" padding="s24" alignItems="center" width="full">
            <Icon.Medium icon="calendar" color="grey600" />
            <Text.Normal weight="semibold" color="grey1000">
              {i18n.t('budgets.detail.period_status.not_started', { days_left: daysLeft })}
            </Text.Normal>
            <Box width="s400" textAlign="center">
              <Text.Normal size="200">
                {budget._policies?.update.can
                  ? i18n.t('budgets.detail.period_status.start_date', {
                      start_date: dateBackendDateTimeToUI(budget.effectiveFrom),
                    })
                  : i18n.t('budgets.detail.period_status.start_date_viewer', {
                      start_date: dateBackendDateTimeToUI(budget.effectiveFrom),
                    })}
              </Text.Normal>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default PeriodStatusCard
